/* eslint-disable  @typescript-eslint/no-explicit-any */

import React, {useContext, useState} from 'react';
import {StyleSheet, View, ViewStyle} from 'react-native';
import {Text} from '..';
import {ThemeContext} from '../ThemeProvider';

function getStyle(pinWidth, reversed, backgroundColor) {
  const theme = useContext(ThemeContext);
  const PIN_Y_SHIFT = -22;
  const PIN_X_SHIFT = 8;
  const REVERSED_PIN_X_SHIFT = -pinWidth - 3;
  const PIN_BORDER_RADIUS = 3;
  const PIN_TRIANGLE_WIDTH = 15;
  const PIN_TRIANGLE_HEIGHT = 5;
  const PIN_CONTAINER_TRANSFORMS = [
    {translateX: reversed ? REVERSED_PIN_X_SHIFT : PIN_X_SHIFT},
    {translateY: PIN_Y_SHIFT},
  ];
  const PIN_TRIANGLE_TRANSFORMS = [
    {scaleX: reversed ? -1 : 1},
    {translateX: reversed ? -pinWidth + 15 : 0},
    {translateY: -1},
  ];
  return StyleSheet.create({
    container: {
      // transform: PIN_CONTAINER_TRANSFORMS,
    },
    pin: {
      justifyContent: 'center',
      alignItems: 'center',
      padding: 3,
      backgroundColor,
      borderTopLeftRadius: PIN_BORDER_RADIUS,
      borderTopRightRadius: PIN_BORDER_RADIUS,
      borderBottomRightRadius: !reversed ? PIN_BORDER_RADIUS : 0,
      borderBottomLeftRadius: reversed ? PIN_BORDER_RADIUS : 0,
    },
    triangleCorner: {
      width: 0,
      height: 0,
      backgroundColor: 'transparent',
      borderStyle: 'solid',
      borderRightWidth: PIN_TRIANGLE_WIDTH,
      borderTopWidth: PIN_TRIANGLE_HEIGHT,
      borderRightColor: 'transparent',
      borderTopColor: backgroundColor,
      // transform: PIN_TRIANGLE_TRANSFORMS,
    },
    text: {
      textAlign: 'center',
      fontSize: theme.font.size.regular,
      fontWeight: theme.font.weight.bold,
      color: 'white',
      backgroundColor: 'transparent',
    },
  });
}

interface ChartPinProps {
  text: string;
  color: string;
  reversed: boolean;
  style: ViewStyle | null;
}

export const ChartPin = ({style, reversed, color, text}: ChartPinProps) => {
  const [state, setState] = useState({width: 30});
  const styles = getStyle(state.width, reversed, color);

  const onLayout = (event: any) => {
    const {width} = event.nativeEvent.layout;
    setState({width});
  };

  return (
    <View style={[style, styles.container]}>
      <View style={[styles.pin]} onLayout={onLayout}>
        <Text style={styles.text}>{text}</Text>
      </View>
      <View style={[styles.triangleCorner]} />
    </View>
  );
};
